<template>
  <el-input v-model="inputValue" readonly>
    <el-button
      slot="append"
      icon="el-icon-copy-document"
      @click="copyToClipboard"
    ></el-button>
  </el-input>
</template>

<script>
import { Message } from "element-ui";

export default {
  name: "CopyInput",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      inputValue: this.text,
    };
  },
  watch: {
    text(newVal) {
      this.inputValue = newVal;
    },
  },
  methods: {
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.inputValue);
        Message.success("Скопировано в буфер");
      } catch (error) {
        console.error("Failed to copy text: ", error);
        Message.error("Не удалось скопировать текст");
      }
    },
  },
};
</script>
